<template>
  <div
    class="flexDiv"
    style="width: 100%; height: calc(100% - 6.225rem); position: absolute"
  >
    <div style="width:280px;position: absolute;top: -3.5rem;left:calc(50% - 140px);z-index:999">
      <div class="text-white w-100 d-flex"  @click="dialogVisible=true" style="border-radius: 4px;border: 1px solid #9599AD;background: #121831;line-height:36px">
        <i class="ri-search-line ms-4"></i>
        <div class="ms-5">{{$t('page.health-monitoring.search')}}</div>
      </div>
    </div>

    <div class="left d-flex flex-wrap align-content-between position-relative">
      <img
        class="position-absolute"
        style="top: 0; left: 6%; width: 0.3125rem"
        src="../../assets/images/dashboard/linedotted.png"
        alt=""
      />

      <div
        class="border_top m-1 position-relative"
        style="
          width: 100%;
          height: 23%;
          background: linear-gradient(
            91deg,
            rgba(17, 16, 24, 0) 0%,
            rgba(17, 16, 24, 0.51) 100%
          );
          background-blend-mode: overlay;
          border-radius: 1.25rem;
          padding: 0.625rem;
          padding-left: 3.125rem;
        "
      >
        <img
          class="position-absolute"
          style="width: 5.75rem; height: 5.75rem; top: 0.625rem; left: -1.25rem"
          src="../../assets/images/dashboard/Button.png"
          alt=""
        />

        <div style="font-size: 1.25rem; font-weight: 600; line-height: 1.25rem">
          {{ $t("overview_static.dahsboard_page.industry_overview") }}
        </div>
        <div
          class="d-flex align-items-center"
          style="color: #7abdff; font-size: 0.9375rem; font-weight: 600"
        >
          <div class="me-2">{{ $t("overview_static.common.time") }}</div>
          <div
            id="flatDate"
            class="input-group"
            style="
              width: 33%;
              min-width: 12.5rem;
              align-content: center;
              height: 1.875rem;
            "
          >
            <flat-pickr
              placeholder="Select Documentation Date"
              v-model="repairDate"
              :config="startDateConfig"
              class="form-control flatpickr-input border-0 ps-0 pe-0 text-black-50 fs-13 bg-0"
              style="color: #ffffff99; background: #ffffff00"
              id="documentation_datepicker"
              @change="getOverviewIndustry"
            ></flat-pickr>
            <i
              data-toggle
              class="ri-arrow-down-s-line fa fa-calendar mt-1"
              style="color: #b6b7bc; font-size: 1.2rem"
            ></i>
          </div>
        </div>
        <div id="industryStatistics" style="width: 100%; height: 80%"></div>
      </div>
      <div
        class="border_top m-1 position-relative"
        style="
          width: 100%;
          height: 47%;
          background: linear-gradient(
            91deg,
            rgba(17, 16, 24, 0) 0%,
            rgba(17, 16, 24, 0.51) 100%
          );
          background-blend-mode: overlay;
          border-radius: 1.25rem;
          padding: 0.625rem;
          padding-left: 3.125rem;
        "
      >
        <img
          class="position-absolute"
          style="width: 5.75rem; height: 5.75rem; top: 0.625rem; left: -1.25rem"
          src="../../assets/images/dashboard/device.png"
          alt=""
        />
        <div style="font-size: 1.25rem; font-weight: 600; line-height: 1.25rem">
          {{ $t("page.deviceStatus") }}
        </div>
        <div
          class="d-flex align-items-center"
          style="color: #7abdff; font-size: 0.9375rem; font-weight: 600"
        >
          <div class="me-2">{{ $t("overview_static.common.time") }}</div>
          <div
            id="flatDate"
            class="input-group"
            style="width: 33%; min-width: 12.5rem"
          >
            <flat-pickr
              placeholder="Select Documentation Date"
              v-model="repairDate2"
              :config="startDateConfig"
              class="form-control flatpickr-input border-0 ps-0 pe-0 text-black-50 fs-13 bg-0"
              style="color: #ffffff99; background: #ffffff00"
              id="documentation_datepicker"
              @change="getOverviewDeviceStatus"
            ></flat-pickr>
            <i
              data-toggle
              class="ri-arrow-down-s-line fa fa-calendar mt-1"
              style="color: #b6b7bc; font-size: 1.2rem"
            ></i>
          </div>
        </div>
        <div id="deviceStatus" style="width: 100%; height: 40%"></div>
        <div
          style="
            border-radius: 1.25rem;
            background: var(
              --layout-2-notification,
              linear-gradient(
                180deg,
                rgba(49, 58, 91, 0.1) 0%,
                rgba(49, 58, 91, 0.3) 51.85%,
                rgba(49, 58, 91, 0) 100%
              )
            );
            padding: 0.625rem;
            height: 43%;
          "
        >
          <div style="font-size: 1.5rem; font-weight: 500">
            {{ $t("overview_static.dahsboard_page.other_status") }}
          </div>
          <div id="otherStates" style="width: 100%; height: 100%"></div>
        </div>
      </div>
      <div
        class="border_top m-1 position-relative"
        style="
          width: 100%;
          height: 30%;
          background: linear-gradient(
            91deg,
            rgba(17, 16, 24, 0) 0%,
            rgba(17, 16, 24, 0.51) 100%
          );
          background-blend-mode: overlay;
          border-radius: 1.25rem;
          padding: 0.625rem;
          padding-left: 3.125rem;
        "
      >
        <img
          class="position-absolute"
          style="width: 5.75rem; height: 5.75rem; top: 0.625rem; left: -1.25rem"
          src="../../assets/images/dashboard/product.png"
          alt=""
        />
        <div style="font-size: 1.25rem; font-weight: 600; line-height: 1.25rem">
          {{ $t("page.product-info.type") }}
        </div>
        <div
          class="d-flex align-items-center"
          style="color: #7abdff; font-size: 0.9375rem; font-weight: 600"
        >
          <div class="me-2">{{ $t("overview_static.common.time") }}</div>
          <div
            id="flatDate"
            class="input-group"
            style="width: 33%; min-width: 12.5rem"
          >
            <flat-pickr
              placeholder="Select Documentation Date"
              v-model="repairDate3"
              :config="startDateConfig"
              class="form-control flatpickr-input border-0 ps-0 pe-0 text-black-50 fs-13 bg-0"
              style="color: #ffffff99; background: #ffffff00"
              id="documentation_datepicker"
              @change="getProductType"
            ></flat-pickr>
            <i
              data-toggle
              class="ri-arrow-down-s-line fa fa-calendar mt-1"
              style="color: #b6b7bc; font-size: 1.2rem"
            ></i>
          </div>
        </div>
        <div id="productType" style="width: 100%; height: 70%"></div>
      </div>
    </div>
    <div class="main position-relative">
      <div
        class="outsideBox d-flex justify-content-center align-content-around flex-wrap"
      >
        <div
          class="d-flex justify-content-center align-items-center"
          :class="[box_active == 'setting' && 'i_box_active']"
          style="
            width: 1.5rem;
            height: 1.5rem;
            border-radius: 50%;
            cursor: pointer;
          "
          @click="mapChange('setting')"
        >
          <i class="text-white fs-14 ri-settings-5-line"></i>
        </div>
        <div
          class="d-flex justify-content-center align-items-center"
          :class="[box_active == 'hand_heart' && 'i_box_active']"
          style="
            width: 1.5rem;
            height: 1.5rem;
            border-radius: 50%;
            cursor: pointer;
          "
          @click="mapChange('hand_heart')"
        >
          <i class="text-white fs-14 ri-hand-heart-fill"></i>
        </div>

        <div
          class="i_box d-flex justify-content-center align-content-around flex-wrap"
        >
          <div
            class="d-flex justify-content-center align-items-center"
            :class="[boxc_active == 'pie_chart' && 'c_box_active']"
            style="
              width: 1.125rem;
              height: 1.125rem;
              border-radius: 50%;
              cursor: pointer;
            "
            @click="mapcChange('pie_chart')"
          >
            <i class="text-white fs-12 ri-pie-chart-fill"></i>
          </div>
          <div
            class="d-flex justify-content-center align-items-center"
            :class="[boxc_active == 'flashlight' && 'c_box_active']"
            style="
              width: 1.125rem;
              height: 1.125rem;
              border-radius: 50%;
              cursor: pointer;
            "
            @click="mapcChange('flashlight')"
          >
            <i
              v-if="box_active == 'setting'"
              class="text-white fs-12 ri-remote-control-fill"
            ></i>
            <i v-else class="text-white fs-12 ri-flashlight-fill"></i>
          </div>
        </div>
      </div>
      <div
        class="w-100 d-flex justify-content-center position-absolute"
        style="top: 0"
      >
        <div
          style="width: 95%; margin-left: 5%"
          class="d-flex justify-content-around"
        >

          <div
            style="width: 24%; max-width: 16rem"
            class="select_box d-flex justify-content-around align-content-center align-items-center"
          >
            <div style="color: #7abdff; width: 4.5rem; text-align: center">
              {{ $t("overview_static.common.industry") }}:
            </div>
            <div class="select_input">
              <el-select
                popper-class="select_popper"
                v-model="industry"
                clearable
                :placeholder="$t('page.select-industry')"
                @change="mapDataChange"
                :teleported="false"
              >
                <el-option
                  v-for="item in industryOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div
            style="width: 24%; max-width: 16rem"
            class="select_box d-flex justify-content-around align-content-center align-items-center"
          >
            <div style="color: #7abdff; width: 4.5rem; text-align: center">
              {{ $t("overview_static.common.customer") }}:
            </div>
            <div class="select_input">
              <el-select
                popper-class="select_popper"
                v-model="attr"
                :placeholder="$t('also.please select')"
                @change="mapDataChange"
                :loading="loading"
                :teleported="false"
                clearable
              >
                <el-option
                  v-for="item in clientName"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div
            style="width: 24%; max-width: 16rem"
            class="select_box d-flex justify-content-around align-content-center align-items-center"
          >
            <div style="color: #7abdff; width: 4.5rem; text-align: center">
              {{ $t("overview_static.device") }}:
            </div>
            <div class="select_input">
              <el-cascader
                popper-class="select_popper"
                :placeholder="$t('also.please select')"
                v-model="product"
                :options="cascaderOptions"
                :props="cascaderProps"
                :show-all-levels="false"
                @change="mapDataChange"
                :teleported="false"
                collapse-tags
                clearable
              >
                <template #default="{ data }">
                  <span>{{
                    data.is_import_pump ? data.name + " ★" : data.name
                  }}</span>
                </template>
              </el-cascader>
            </div>
          </div>
          <div
            style="width: 24%; max-width: 16rem"
            class="select_box d-flex justify-content-around align-content-center align-items-center"
          >
            <div style="color: #7abdff; width: 4rem; text-align: center">
              {{ $t("overview_static.common.time") }}:
            </div>
            <div
              class="select_input custom-class overflow-hidden"
              style="width: 90%"
            >
              <el-date-picker
                style="width: 12.5rem"
                v-model="value2"
                type="daterange"
                size="small"
                align="right"
                unlink-panels
                :range-separator="rangeSeparator"
                start-placeholder=""
                end-placeholder=""
                :shortcuts="shortcuts"
                @change="mapDataChange"
                :teleported="false"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
      </div>
      <img
        class="position-absolute top-0 left-0"
        style="width: 100%; height: 80%"
        src="../../utils/廓形.png"
        alt=""
      />
      <div id="chinaMap" style="width: 100%; height: 90%"></div>
      <div class="w-100 d-flex justify-content-center">
        <div
          class="d-flex justify-content-around position-absolute"
          style="
            width: 90%;
            padding: 0.625rem 2.25rem;
            background: rgba(196, 196, 196, 0.07);
            backdrop-filter: blur(0.625rem);
            border-radius: 1.5625rem;
            margin: 0 auto;
            bottom: 10%;
          "
        >
          <div>
            <div
              style="font-size: 2.25rem; font-weight: 700; text-align: center"
            >
              {{ overviewSiteData.device_total
              }}{{ this.$t('overview_static.common["台"]') }}
            </div>
            <div
              style="
                font-size: 1.25rem;
                font-weight: 500;
                color: #ccc6c6;
                text-align: center;
              "
            >
              {{ this.$t("overview_static.common.device")
              }}{{ this.$t("overview_static.common.amount") }}
            </div>
          </div>
          <div>
            <div
              style="font-size: 2.25rem; font-weight: 700; text-align: center"
            >
              {{ overviewSiteData.customer_total
              }}{{ this.$t('overview_static.common["个"]') }}
            </div>
            <div
              style="
                font-size: 1.25rem;
                font-weight: 500;
                color: #ccc6c6;
                text-align: center;
              "
            >
              {{ this.$t("overview_static.common.customer")
              }}{{ this.$t("overview_static.common.amount") }}
            </div>
          </div>
          <div>
            <div
              style="font-size: 2.25rem; font-weight: 700; text-align: center"
            >
              {{ overviewSiteData.order_total
              }}{{ this.$t('overview_static.common["单"]') }}
            </div>
            <div
              style="
                font-size: 1.25rem;
                font-weight: 500;
                color: #ccc6c6;
                text-align: center;
              "
            >
              {{ this.$t("overview_static.common.work_order")
              }}{{ this.$t("overview_static.common.amount") }}
            </div>
          </div>
          <div v-if="false">
            <div
              style="font-size: 2.25rem; font-weight: 700; text-align: center"
            >
              {{ overviewSiteData.bo_total
              }}{{ this.$t('overview_static.common["单"]') }}
            </div>
            <div
              style="
                font-size: 1.25rem;
                font-weight: 500;
                color: #ccc6c6;
                text-align: center;
              "
            >
              {{ this.$t("overview_static.business_opportunity")
              }}{{ this.$t("overview_static.common.amount") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right d-flex flex-wrap align-content-between position-relative">
      <img
        class="position-absolute"
        style="top: 0; left: 6%; width: 0.3125rem"
        src="../../assets/images/dashboard/linedotted.png"
        alt=""
      />
   
      <div
        class="border_top m-1 position-relative"
        style="
          width: 100%;
          height: 40%;
          background: linear-gradient(
            91deg,
            rgba(17, 16, 24, 0) 0%,
            rgba(17, 16, 24, 0.51) 100%
          );
          background-blend-mode: overlay;
          border-radius: 1.25rem;
          padding: 0.625rem;
          padding-left: 3.125rem;
        "
      >
        <img
          class="position-absolute"
          style="width: 5.75rem; height: 5.75rem; top: 0.625rem; left: -1.25rem"
          src="../../assets/images/dashboard/order.png"
          alt=""
        />
        <div style="font-size: 1.25rem; font-weight: 600; line-height: 1.25rem">
          {{ $t("overview_static.dahsboard_page.work_order") }}
        </div>
        <div
          class="d-flex align-items-center"
          style="color: #7abdff; font-size: 0.9375rem; font-weight: 600"
        >
          <div class="me-2">{{ $t("overview_static.common.time") }}</div>
          <div
            id="flatDate"
            class="input-group"
            style="width: 33%; min-width: 12.5rem"
          >
            <flat-pickr
              placeholder="Select Documentation Date"
              v-model="repairDate6"
              :config="startDateConfig"
              class="form-control flatpickr-input border-0 ps-0 pe-0 text-black-50 fs-13 bg-0"
              style="color: #ffffff99; background: #ffffff00"
              id="documentation_datepicker"
              @change="getOverviewWorkOrder"
            ></flat-pickr>
            <i
              data-toggle
              class="ri-arrow-down-s-line fa fa-calendar mt-1"
              style="color: #b6b7bc; font-size: 1.2rem"
            ></i>
          </div>
        </div>
        <div class="w-100 d-flex justify-content-between">
          <div id="inTime" style="width: 5rem; height: 5rem"></div>
          <div id="inTime2" style="width: 5rem; height: 5rem"></div>
          <div id="inTime3" style="width: 5rem; height: 5rem"></div>
          <div id="inTime4" style="width: 5rem; height: 5rem"></div>
        </div>
        <div class="fs-15">
          {{ $t("overview_static.dahsboard_page.customer_satisfaction_score") }}
        </div>
        <div
          class="d-flex align-items-center justify-content-between align-content-center"
        >
          <div style="width: 75%">
            <div class="progress mt-2">
              <div
                class="progress-bar"
                :style="{
                  background: 'rgb(33, 210, 249)',
                  width: overviewWorkOrderData['satisfied_total'] + '%',
                }"
                role="progressbar"
                :aria-valuenow="overviewWorkOrderData['satisfied_total']"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <div
              class="w-100 d-flex justify-content-between position-relative"
              style="font-size: 0.75rem; font-weight: 500"
            >
              <div
                class="position-absolute"
                :style="{
                  left: overviewWorkOrderData['satisfied_total'] - 3 + '%',
                  top: '-.9375rem',
                }"
              >
                <img src="../../assets/images/dashboard/group1.png" alt="" />
              </div>
            </div>
          </div>
          <div class="mt-2">
            {{ overviewWorkOrderData["satisfied_total"] }}
            {{ $t('overview_static.common["分"]') }} / 5
            {{ $t('overview_static.common["分"]') }}
          </div>
        </div>
        <div id="equipmentMaintenance" style="width: 100%; height: 50%"></div>
      </div>
    </div>
    <el-drawer @open="handleShow" v-model="dialogVisible" style="background-color: transparent;box-shadow: none"  size="30%" direction="ttb" title="I am the title" :with-header="false">
      <div style="background: rgb(18, 24, 49);padding:20px">
        <el-autocomplete
            ref="autoInput"
            class="top-auto-complete"
            popper-class="separator-autocomplete"
            v-model="searchText"
            :fetch-suggestions="querySearchAsync"
            :placeholder="$t('page.health-monitoring.search')"
            @select="handleSelect"
            value-key="name"
            prefix-icon="el-icon-search"
            :teleported="false"
            :trigger-on-focus="true"
        >
        </el-autocomplete>

      </div>
    </el-drawer>
  </div>
</template>
<script>
import {
  industryStatisticsEcharts,
  deviceStatusEcharts,
  otherStatesEcharts,
  chinaEcharts,
  productTypeEcharts,
  outputBagsChart,
  opportunityEcharts,
  pieEcharts,
  equipmentMaintenanceEcharts,
} from "@/utils/dashboardChart";
import {
  overviewIndustry,
  overviewDeviceStatus,
  overviewProductType,
  overviewSite,
  overviewService,
  overviewWorkOrder,
  overviewSiteCustomer,
  overviewTaskLostReason,
  overviewSiteDevice,
  overviewOrderStatus,
  overviewWorkload,
  getModelList,
  getCustomerOptions
} from "@/service/index";
import { getCustomers } from "@/helpers/common-service";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import * as echarts from "echarts";
import _ from "lodash";
import { CUSTOMER_INDUSTRY_LIST, API_SVC_HOST } from "@/config/common";
import i18n from "@/i18n";
import router from "@/router";
const industryOptions = [
  { value: "", label: i18n.global.t("page.all") },
  ...CUSTOMER_INDUSTRY_LIST,
];

const arrMap = [
  "北京市",
  "重庆市",
  "陕西省",
  "浙江省",
  "内蒙古自治区",
  "甘肃省",
  "江苏省",
  "山东省",
  "河北省",
  "四川省",
  "云南省",
  "辽宁省",
  "吉林省",
  "广东省",
  "天津市",
  "山西省",
  "出口",
  "新疆维吾尔自治区",
  "黑龙江省",
  "宁夏回族自治区",
  "河南省",
  "上海市",
  "海南省",
  "安徽省",
  "青海省",
  "湖北省",
  "广西壮族自治区",
  "福建省",
  "贵州省",
  "西藏自治区",
  "江西省",
  "湖南省",
];
export default {
  data() {
    return {
      dialogVisible: false,
      restaurants: [],
      searchText: '',
      timeout:  null,
      industryOptions,
      rangeSeparator: this.$t("base.to").toLowerCase(),
      shortcuts: [
        {
          text: this.$t("page.atlas-analysis.Last7Days"),
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          },
        },
        {
          text: this.$t("page.atlas-analysis.ThisMonth"),
          value: () => {
            const end = moment().endOf("month").valueOf();
            const start = moment().startOf("month").valueOf();
            return [start, end];
          },
        },
        {
          text: this.$t("page.atlas-analysis.TMonth"),
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          },
        },
      ],
      /*moment().subtract(1, "year").format("YYYY-MM-DD")*/ 
      value2: [
        '1996-02-29',
        moment().format("YYYY-MM-DD"),
      ],
      language: "",
      box_active: "setting",
      boxc_active: "pie_chart",
      cascaderOptions: [],
      cascaderProps: { multiple: true, value: "id", label: "name" },
      clientName: [
        { value: "普通", label: this.$t("普通") },
        { value: "KA", label: this.$t("KA") },
        { value: "配套户", label: this.$t("配套户") },
        { value: "工程公司", label: this.$t("工程公司") },
        { value: "出口", label: this.$t("出口") },
      ],
      loading: false,
      hasMore: false,
      value: "",
      startDateConfig: {
        wrap: true,
        altInput: true,
        altFormat: "Y-m-d", //选择时显示的时间
        dateFormat: "Y-m-d",
        mode: "range",
        allowInput: true, //是否允许用户直接在输入框中输入日期。
        appendTo: document.getElementById("app"),
        shorthandCurrentMonth: true,
      },
      repairDate:
        '1996-02-29' +
        " " +
        this.$t("base.to").toLowerCase() +
        " " +
        moment().format("YYYY-MM-DD"),
      repairDate2:
        '1996-02-29' +
        " " +
        this.$t("base.to").toLowerCase() +
        " " +
        moment().format("YYYY-MM-DD"),
      repairDate3:
        '1996-02-29' +
        " " +
        this.$t("base.to").toLowerCase() +
        " " +
        moment().format("YYYY-MM-DD"),
      repairDate4:
        '1996-02-29' +
        " " +
        this.$t("base.to").toLowerCase() +
        " " +
        moment().format("YYYY-MM-DD"),
      repairDate5:
        '1996-02-29' +
        " " +
        this.$t("base.to").toLowerCase() +
        " " +
        moment().format("YYYY-MM-DD"),
      repairDate6:
        '1996-02-29' +
        " " +
        this.$t("base.to").toLowerCase() +
        " " +
        moment().format("YYYY-MM-DD"),
      overviewSiteData: {},
      overviewServiceData: {},
      overviewWorkOrderData: {},
      timmer: null,
      timeData: "",
      yearData: "",
      weekData: "",
      fullscreen: false,
      pathType: "dashboard",
      industry: "",
      attr: "",
      product: "",
      popUpMessage: {
        setting: {
          已绑定: this.$t("overview_static.dahsboard_page.barcode_attached"),
          未绑定: this.$t("overview_static.dahsboard_page.barcode_unattached"),
          报废: this.$t("overview_static.dahsboard_page.wasted"),
          工单总量: this.$t(
            "overview_static.dahsboard_page.map_area.order_amount"
          ),
          商机总量: this.$t(
            "overview_static.dahsboard_page.map_area.bo_amount"
          ),
          客户总量: this.$t(
            "overview_static.dahsboard_page.map_area.customer_amount"
          ),
          进行中工单总量: this.$t(
            "overview_static.dahsboard_page.map_area.order_in_progress"
          ),
        },

        iot: {
          "非IoT 设备": this.$t(
            "overview_static.dahsboard_page.map_area.non_iot_device"
          ),
        },
        work: {
          工单总量: this.$t(
            'overview_static.dahsboard_page.map_area["order_amount"]'
          ),
          进行中工单总量: this.$t(
            'overview_static.dahsboard_page.map_area["order_in_progress"]'
          ),
          完成工单总量: this.$t(
            'overview_static.dahsboard_page.map_area["order_completed"]'
          ),
          商机总量: this.$t(
            'overview_static.dahsboard_page.map_area["bo_amount"]'
          ),
        },
        load: {
          工单负荷量: this.$t(
            'overview_static.dahsboard_page.map_area["workload"]'
          ),
        },
        unit: {
          天: this.$t('overview_static.common["天"]'),
          个: this.$t('overview_static.common["个"]'),
          台: this.$t('overview_static.common["台"]'),
          单: this.$t('overview_static.common["单"]'),
        },
      },
      pBobj: {
        setting: this.$t('overview_static.dahsboard_page.map_area["设备数量"]'),
        iot: this.$t('overview_static.dahsboard_page.map_area["设备数量"]'),
        work: this.$t('overview_static.dahsboard_page.map_area["服务数量"]'),
        load: this.$t("overview_static.dahsboard_page.map_area.workload"),
      },
    };
  },
  components: {
    flatPickr,
  },
  computed: {
    icon() {
      return this.fullscreen ? "ri-fullscreen-exit-line" : "ri-fullscreen-line";
    },
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
    logoutUrl() {
      return _.trimEnd(_.trim(API_SVC_HOST, '"'), "/") + "/logout";
    },
  },
  mounted() {
    this.getModelList();
    this.getOverviewIndustry();
    this.getOverviewDeviceStatus();
    this.getProductType();
    this.getOverviewSite();
    this.getOverviewWorkOrder();
    this.getService();
    this.getBusinessOpportunity();
    // this.customers()
  },

  methods: {
    handleShow() {

      this.$nextTick(() => {
        console.log(this.$refs.autoInput)
        this.$refs.autoInput.focus();
      });
    },
    querySearchAsync(queryString, cb) {
      let params={
        page_size:0,
        keyword:queryString
      }
      getCustomerOptions(params).then(res=>{
        console.log(res)
        if(res.payload&&res.payload.results){
          cb(res.payload.results)
        }
        if(res&&res.payload){
          cb(res.payload)
        }
      })
    },
    handleSelect(item) {
      console.log(item);
      router.push('/fullIndex?path=4&id='+item.id)
    },
    logout() {
      var form = document.getElementById("frm_logout");
      form.action = this.logoutUrl;
      form.submit();
      sessionStorage.setItem("is_logout", "true");
      setTimeout(() => {
        localStorage.clear();
      }, 2000);
    },
    skipPage(path) {
      this.pathType = path;
      this.$router.push("/" + path);
    },
    //全屏
    fullele() {
      return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement ||
        document.mozFullScreenElement ||
        null
      );
    },

    //判断是否全屏
    isFullScreen() {
      return !!(document.webkitIsFullScreen || this.fullele());
    },
    //退出全屏
    exitFullscreen() {
      this.fullscreen = false;

      if (document.exitFullScreen) {
        document.exitFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    //全屏
    full(ele) {
      if (ele.requestFullscreen) {
        ele.requestFullscreen();
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen();
      } else if (ele.webkitRequestFullscreen) {
        ele.webkitRequestFullscreen();
      } else if (ele.msRequestFullscreen) {
        ele.msRequestFullscreen();
      }
    },
    //切换是否全屏 全屏按钮要执行的方法
    toggleFullScreen() {
      if (this.isFullScreen()) {
        this.exitFullscreen();
      } else {
        this.fullscreen = true;
        this.full(document.getElementById("dashboardBox")); //要设置全屏的元素
      }
    },
    changeLang(lang) {
      this.language = lang;
      localStorage.setItem("language", lang);
      // 设置i18n.locale 组件库会按照上面的配置使用对应的文案文件
      // this.$i18n.locale = lang;
      window.location.reload();
    },
    Refresh() {
      window.location.reload();
    },
    moment,
    getOverviewIndustry() {
      let params = {
        start:
          moment(
            this.repairDate.split(this.$t("base.to").toLowerCase())[0].trim()
          ).format("YYYY-MM-DD") || "",
        end:
          moment(
            this.repairDate.split(this.$t("base.to").toLowerCase())[1].trim()
          ).format("YYYY-MM-DD") || "",
      };
      overviewIndustry(params).then((res) => {
        if (res && res.payload) {
          industryStatisticsEcharts({
            chartDom: document.getElementById("industryStatistics"),
            dataList: res.payload,
            xData: [
              this.$t('overview_dynamic.industy_dict["化工"]'),
              this.$t('overview_dynamic.industy_dict["油气"]'),
              this.$t('overview_dynamic.industy_dict["造纸"]'),
              this.$t('overview_dynamic.industy_dict["电力"]'),
              this.$t('overview_dynamic.industy_dict["核电"]'),
              this.$t('overview_dynamic.industy_dict["通用"]'),
            ],
            dataType: [
              this.$t("overview_static.device"),
              this.$t("overview_static.work_order"),
              this.$t("overview_static.common.customer"),
            ],
          });
        }
      });
    },
    getOverviewDeviceStatus() {
      let params = {
        start:
          moment(
            this.repairDate2.split(this.$t("base.to").toLowerCase())[0].trim()
          ).format("YYYY-MM-DD") || "",
        end:
          moment(
            this.repairDate2.split(this.$t("base.to").toLowerCase())[1].trim()
          ).format("YYYY-MM-DD") || "",
      };
      overviewDeviceStatus(params).then((res) => {
        if (res && res.payload) {
          deviceStatusEcharts({
            chartDom: document.getElementById("deviceStatus"),
            dataList: res.payload,
            title:
              res.payload["IoT Ready"] +
              // res.payload["IoT Activated"] +
              res.payload["Not IoT"],
            unit: this.$t('overview_static.common["台"]'),
            dataLot: [
              {
                name: "IoT Ready",
                value: res.payload["IoT Ready"]||0,
                // label: { show: res.payload["IoT Ready"] > 0 ? true : false },
              },
              {
                name: "IoT Activated",
                value: res.payload["IoT Activated"]||0,
                label: {
                  //   show: res.payload["IoT Activated"] > 0 ? true : false,
                },
              },
              {
                name: this.$t("overview_static.dahsboard_page.non_iot_device"),
                value: res.payload["Not IoT"]||0,
                // label: { show: res.payload["Not IoT"] > 0 ? true : false },
              },
            ],
          });
          otherStatesEcharts({
            chartDom: document.getElementById("otherStates"),
            dataList: {
              [this.$t("overview_static.dahsboard_page.barcode_attached")]: res
                .payload["已绑定"],
              [this.$t(
                "overview_static.dahsboard_page.barcode_unattached"
              )]: res.payload["未绑定"],
              [this.$t("overview_static.dahsboard_page.wasted")]: res.payload[
                "报废"
              ],
            },
            unit: this.$t('overview_static.common["台"]'),
            legendData: [
              {
                name: this.$t(
                  "overview_static.dahsboard_page.barcode_attached"
                ),
                itemStyle: { color: "#33A087" },
              },
              {
                name: this.$t(
                  "overview_static.dahsboard_page.barcode_unattached"
                ),
                itemStyle: { color: "#F0DD73" },
              },
              {
                name: this.$t("overview_static.dahsboard_page.wasted"),
                itemStyle: { color: "#5471BD" },
              },
            ],
          });
        }
      });
    },
    getProductType() {
      let params = {
        start:
          moment(
            this.repairDate3.split(this.$t("base.to").toLowerCase())[0].trim()
          ).format("YYYY-MM-DD") || "",
        end:
          moment(
            this.repairDate3.split(this.$t("base.to").toLowerCase())[1].trim()
          ).format("YYYY-MM-DD") || "",
      };
      overviewProductType(params).then((res) => {
        if (res && res.payload) {
          productTypeEcharts({
            chartDom: document.getElementById("productType"),
            unit: this.$t('overview_static.common["台"]'),
            dataList: [
              {
                value: res.payload["液环真空泵"] || 0,

                name: this.$t('overview_dynamic.device_type_dict["液环泵"]'),
              },
              {
                value: res.payload["罗茨泵"] || 0,

                name: this.$t('overview_dynamic.device_type_dict["罗茨泵"]'),
              },
              {
                value: res.payload["干泵"] || 0,

                name: this.$t('overview_dynamic.device_type_dict["干泵"]'),
              },
              {
                value: res.payload["风机"] || 0,

                name: this.$t('overview_dynamic.device_type_dict["风机"]'),
              },
            ],
            valueList: {
              [this.$t('overview_dynamic.device_type_dict["液环泵"]')]:
                res.payload["液环真空泵"] || 0,
              [this.$t('overview_dynamic.device_type_dict["罗茨泵"]')]:
                res.payload["罗茨泵"] || 0,
              [this.$t('overview_dynamic.device_type_dict["干泵"]')]:
                res.payload["干泵"] || 0,
              [this.$t('overview_dynamic.device_type_dict["风机"]')]:
                res.payload["风机"] || 0,
            },
            legendData: [
              this.$t('overview_dynamic.device_type_dict["液环泵"]'),
              this.$t('overview_dynamic.device_type_dict["罗茨泵"]'),
              this.$t('overview_dynamic.device_type_dict["干泵"]'),
              this.$t('overview_dynamic.device_type_dict["风机"]'),
            ],
          });
        }
      });
    },
    getOverviewSite() {
      let params = {
        start: moment(this.value2[0]).format("YYYY-MM-DD") || "",
        end: moment(this.value2[1]).format("YYYY-MM-DD") || "",
        industry: this.industry,
        attr: this.attr,
        product: this.product.toString(),
      };
      overviewSite(params).then((res) => {
        if (res && res.payload) {
          this.overviewSiteData = res.payload;
          chinaEcharts(
            {
              chartDom: document.getElementById("chinaMap"),
              pBobj: this.pBobj,
              popUpMessage: this.popUpMessage,
              dataList: res.payload,
              name: "china",
              type: "setting",
              max: 1000,
              min: 0,
              inRange: {
                color: ["#D26363", "#E1D699", "#DFD28D", "#86C4B5", "#91D5C5"],
              },
            },
            this.getProvince
          );
        }
      });
    },
    getProvince(options) {
      if (this.box_active == "setting" && this.boxc_active == "pie_chart") {
        if (options.name) {
          arrMap.map((item) => {
            if (item.includes(options.name)) {
              let params = {
                province: item,
                start: moment(this.value2[0]).format("YYYY-MM-DD") || "",
                end: moment(this.value2[1]).format("YYYY-MM-DD") || "",
                industry: this.industry,
                attr: this.attr,
                product: this.product.toString(),
              };

              overviewSiteCustomer(params).then((res) => {
                if (res && res.payload) {
                  this.overviewSiteData = res.payload;
                  chinaEcharts({
                    chartDom: document.getElementById("chinaMap"),
                    pBobj: this.pBobj,
                    popUpMessage: this.popUpMessage,
                    dataList: res.payload,
                    name: options.name,
                    type: "setting",
                    max: 200,
                    min: 0,
                    inRange: {
                      color: [
                        "#D36868",
                        "#D8BB71",
                        "#DACF6A",
                        "#80B8AB",
                        "#267863",
                      ],
                    },
                  });
                }
              });
            }
          });
        } else {
          this.getOverviewSite();
        }
      }
    },
    getOverviewWorkOrder() {
      let params = {
        start:
          moment(
            this.repairDate6.split(this.$t("base.to").toLowerCase())[0].trim()
          ).format("YYYY-MM-DD") || "",
        end:
          moment(
            this.repairDate6.split(this.$t("base.to").toLowerCase())[1].trim()
          ).format("YYYY-MM-DD") || "",
      };
      overviewWorkOrder(params).then((res) => {
        if (res && res.payload) {
          this.overviewWorkOrderData = res.payload;
          equipmentMaintenanceEcharts({
            chartDom: document.getElementById("equipmentMaintenance"),
            dataList: res.payload,
            unit: this.$t('overview_static.common["单"]'),
            allData: [],
            wData: [
              {
                value: res.payload.type_count["1"],
                name: this.$t('overview_dynamic.order_type_dict["设备维修"]'),
              },
              {
                value: res.payload.type_count["2"]["1"],
                name: this.$t('overview_dynamic.service_type_dict["日常保养"]'),
              },

              {
                value: res.payload.type_count["3"],
                name: this.$t('overview_dynamic.order_type_dict["安装调试"]'),
              },
              {
                value: res.payload.type_count["4"],
                name: this.$t('overview_dynamic.order_type_dict["故障排除"]'),
              },
              {
                value: res.payload.type_count["5"],
                name: this.$t('overview_dynamic["点巡检"]'),
              },
            ],
            valueData: [
              {
                value: res.payload.type_count["1"],
                name: this.$t('overview_dynamic.order_type_dict["设备维修"]'),
              },
              {
                value: res.payload.type_count["2"]["1"],
                name: this.$t('overview_dynamic.service_type_dict["日常保养"]'),
              },
              {
                value: res.payload.type_count["2"]["2"],
                name: this.$t('overview_dynamic.service_type_dict["一级保养"]'),
              },
              {
                value: res.payload.type_count["2"]["3"],
                name: this.$t('overview_dynamic.service_type_dict["二级保养"]'),
              },
              {
                value: res.payload.type_count["2"]["4"],
                name: this.$t('overview_dynamic.service_type_dict["返厂大修"]'),
              },
              {
                value: res.payload.type_count["3"],
                name: this.$t('overview_dynamic.order_type_dict["安装调试"]'),
              },
              {
                value: res.payload.type_count["4"],
                name: this.$t('overview_dynamic.order_type_dict["故障排除"]'),
              },
              {
                value: res.payload.type_count["5"],
                name: this.$t('overview_dynamic["点巡检"]'),
              },
            ],
            legendData1: [
              this.$t('overview_dynamic.order_type_dict["设备维修"]'),
              this.$t('overview_dynamic.service_type_dict["日常保养"]'),
              this.$t('overview_dynamic.service_type_dict["一级保养"]'),
              this.$t('overview_dynamic.service_type_dict["二级保养"]'),
            ],
            legendData2: [
              this.$t('overview_dynamic.service_type_dict["返厂大修"]'),
              this.$t('overview_dynamic.order_type_dict["安装调试"]'),
              this.$t('overview_dynamic.order_type_dict["故障排除"]'),
              this.$t('overview_dynamic["点巡检"]'),
            ],
          });
          pieEcharts({
            chartDom: document.getElementById("inTime"),
            dataList: res.payload["timely_confirmed_total"] || 0,
            title: this.$t("overview_static.dahsboard_page.responsed_on_time"),
            color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
              {
                offset: 0,
                color: "#6FBC7A",
              },
              {
                offset: 0.5,
                color: "#499854",
              },
              {
                offset: 1,
                color: "#94F2A1",
              },
            ]),
          });
          pieEcharts({
            chartDom: document.getElementById("inTime2"),
            dataList: res.payload["timely_closed_total"] || 0,
            title: this.$t("overview_static.dahsboard_page.closed_on_time"),
            color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
              {
                offset: 0,
                color: "#59EDC9",
              },
              {
                offset: 0.5,
                color: "#2DAF91",
              },
              {
                offset: 1,
                color: "#1D9275",
              },
            ]),
          });
          pieEcharts({
            chartDom: document.getElementById("inTime3"),
            dataList: res.payload["satisfied_total"] || 0,
            title: this.$t("overview_static.dahsboard_page.done"),
            color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
              {
                offset: 0,
                color: "#6463D6",
              },
              {
                offset: 0.5,
                color: "#434289",
              },
              {
                offset: 1,
                color: "#7373E1",
              },
            ]),
          });
          pieEcharts({
            chartDom: document.getElementById("inTime4"),
            dataList: res.payload["score_avg"] || 0,
            title: this.$t(
              "overview_static.dahsboard_page.customer_satisfaction"
            ),
            color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
              {
                offset: 0,
                color: "#11EFFD",
              },
              {
                offset: 0.5,
                color: "#3FB5CF",
              },
              {
                offset: 1,
                color: "#3CC1EE",
              },
            ]),
          });
        }
      });
    },
    getService() {
      let params = {
        start:
          moment(
            this.repairDate4.split(this.$t("base.to").toLowerCase())[0].trim()
          ).format("YYYY-MM-DD") || "",
        end:
          moment(
            this.repairDate4.split(this.$t("base.to").toLowerCase())[1].trim()
          ).format("YYYY-MM-DD") || "",
      };
      overviewService(params).then((res) => {
        if (res && res.payload) {
          this.overviewServiceData = res.payload;
          outputBagsChart({
            chartDom: document.getElementById("outputBags"),
            unit: this.$t('overview_static.common["单"]'),
            title: this.$t('overview_static.dahsboard_page["总计延期量"]'),
            dataList: res.payload,
            valueList: [
              {
                value: _.get(res.payload, ["completed"]) || 1,
                name: this.$t("overview_static.dahsboard_page.converted"),
              },
              {
                value: _.get(res.payload, ["transform"]) || 1,
                name: this.$t("overview_static.dahsboard_page.to_be_converted"),
              },
            ],
          });
        }
      });
    },
    getBusinessOpportunity() {
      let params = {
        start:
          moment(
            this.repairDate5.split(this.$t("base.to").toLowerCase())[0].trim()
          ).format("YYYY-MM-DD") || "",
        end:
          moment(
            this.repairDate5.split(this.$t("base.to").toLowerCase())[1].trim()
          ).format("YYYY-MM-DD") || "",
      };
      overviewTaskLostReason(params).then((res) => {
        if (res && res.payload) {
          let datas = [
            {
              name:this.$t("overview_static['现场无此设备']"),
              value: _.get(res.payload, ["3"], 0),
            },
            {
              name: this.$t("overview_static['预测偏差']"),
              value: _.get(res.payload, ["-1"], 0),
            },
            {
              name: this.$t("overview_static['竞争对手']"),
              value: _.get(res.payload, ["1"], 0),
            },
            {
              name: this.$t("overview_static['供应商直供']"),
              value: _.get(res.payload, ["2"], 0),
            },
            {
              name:this.$t("overview_static['找第三方']"),
              value: _.get(res.payload, ["4"], 0),
            },
            {
              name:this.$t("overview_static['客户自行维保']"),
              value: _.get(res.payload, ["5"], 0),
            },
          ];
          opportunityEcharts({
            chartDom: document.getElementById("opportunity"),
            unit: this.$t('overview_static.common["台"]'),

            dataList: datas,
          });
        }
      });
    },
    //全国lot
    getOverviewSiteDevice() {
      let params = {
        start: moment(this.value2[0]).format("YYYY-MM-DD") || "",
        end: moment(this.value2[1]).format("YYYY-MM-DD") || "",
        industry: this.industry,
        attr: this.attr,
        product: this.product.toString(),
      };
      overviewSiteDevice(params).then((res) => {
        if (res && res.payload) {
          chinaEcharts({
            chartDom: document.getElementById("chinaMap"),
            pBobj: this.pBobj,
            popUpMessage: this.popUpMessage,
            dataList: res.payload,
            name: "china",
            type: "iot",
            max: 1000,
            min: 0,
            inRange: {
              color: ["#D26363", "#E1D699", "#DFD28D", "#86C4B5", "#91D5C5"],
            },
          });
        }
      });
    },
    //全国工单
    getOverviewOrderStatus() {
      let params = {
        start: moment(this.value2[0]).format("YYYY-MM-DD") || "",
        end: moment(this.value2[1]).format("YYYY-MM-DD") || "",
        industry: this.industry,
        attr: this.attr,
        product: this.product.toString(),
      };
      overviewOrderStatus(params).then((res) => {
        //   ["#22366C", "#3372BC",   "#218CD9", "#117EFD", "#11EFFD"]
        if (res && res.payload) {
          chinaEcharts({
            chartDom: document.getElementById("chinaMap"),
            pBobj: this.pBobj,
            popUpMessage: this.popUpMessage,
            dataList: res.payload,
            name: "china",
            type: "work",
            max: 200,
            min: 0,
            inRange: {
              color: ["#D26363", "#E1D699", "#DFD28D", "#86C4B5", "#91D5C5"],
            },
          });
        }
      });
    },
    //全国负荷
    getOverviewWorkload() {
      let params = {
        start: moment(this.value2[0]).format("YYYY-MM-DD") || "",
        end: moment(this.value2[1]).format("YYYY-MM-DD") || "",
        industry: this.industry,
        attr: this.attr,
        product: this.product.toString(),
      };
      overviewWorkload(params).then((res) => {
        if (res && res.payload) {
          chinaEcharts({
            chartDom: document.getElementById("chinaMap"),
            pBobj: this.pBobj,
            popUpMessage: this.popUpMessage,
            dataList: res.payload,
            name: "china",
            type: "load",
            max: 150,
            min: 0,
            inRange: {
            //   color: ["#99E2D1", "#A9F4E3", "#FBEDA2", "#FFF2AB", "#FE7979"],
              color: ["#74807D","#91D5C5", "#86C4B5", "#DFD28D", "#E1D699", "#D26363"],
            },
          });
        }
      });
    },
    //地图切换
    mapChange(type) {
      this.box_active = type;
      this.boxc_active = "pie_chart";
      this.mapDataChange();
    },
    mapcChange(type) {
      this.boxc_active = type;
      this.mapDataChange();
    },
    mapDataChange() {
      if (this.box_active == "setting" && this.boxc_active == "flashlight") {
        this.getOverviewSiteDevice();
      }
      if (this.box_active == "setting" && this.boxc_active == "pie_chart") {
        this.getOverviewSite();
      }
      if (this.box_active == "hand_heart" && this.boxc_active == "pie_chart") {
        this.getOverviewOrderStatus();
      }
      if (this.box_active == "hand_heart" && this.boxc_active == "flashlight") {
        this.getOverviewWorkload();
      }
    },
    //客户
    customers() {
      getCustomers()
        .then((res) => {
          res.map((a) => {
            this.clientName.push({
              label: a.name,
              value: a.id,
              key: a.id + "",
            });
          });
          this.hasMore = false;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getModelList() {
      getModelList({ type: 1 }).then((res) => {
        if (res && res.payload && res.payload.data) {
          this.cascaderOptions = res.payload.data;
        }
      });
    },
  },
};
</script>

<style  lang="scss">
.border_top {
  border-top: 0.0625rem solid;
  border-image: linear-gradient(
      90deg,
      #00000000 5%,
      #3342ff 25%,
      #37f4f4 50%,
      #3342ff 75%,
      #00000000 95%
    )
    2 2 2 2;
  border-radius: 1.25rem;
}

.menuActive {
  border-radius: 0.625rem;
  background: linear-gradient(
      180deg,
      rgba(254, 200, 241, 0.9) 0%,
      rgba(237, 146, 215, 0) 40.39%
    ),
    radial-gradient(
      96.63% 140.33% at 76.68% 66.67%,
      rgba(96, 46, 166, 0) 0%,
      rgba(201, 119, 214, 0.5) 100%
    );
  background-blend-mode: overlay, normal;
  /* Sign Up button */
  box-shadow: 0 0.625rem 0.625rem 0 rgba(0, 0, 0, 0.1),
    0 0 0.3125rem 0 #fface4 inset, 0 -0.0625rem 0.5rem 0 #9375b6 inset;
}
/* 方法三: flex布局*/
.flexDiv {
  display: flex;
}
.left {
  width: 29rem;
}
.main {
  width: 100%;
  /* 方法三 flex布局*/
  flex: 1;
}
.right {
  width: 29rem;
}
.outsideBox {
  border-radius: 30rem;
  padding: 0 0.125rem;
  z-index: 999;
  background: linear-gradient(
    134deg,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(235, 235, 235, 0.37) 20.07%,
    rgba(224, 224, 224, 0.29) 28.14%,
    rgba(212, 212, 212, 0.21) 39.91%,
    rgba(207, 207, 207, 0.18) 48.1%,
    rgba(202, 202, 202, 0.14) 53.59%,
    rgba(200, 200, 200, 0.13) 58.73%,
    rgba(196, 196, 196, 0.1) 66.8%
  );
  box-shadow: 0 0.0625rem 1.5rem -0.0625rem rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(0.75rem);
  width: 1.65rem;
  height: 9.625rem;
  position: absolute;
  top: 0rem;
  left: 0.5rem;
}
.i_box {
  height: 3.75rem;
  width: 1.5625rem;
  border-radius: 31.25rem;
  background: linear-gradient(
    134deg,
    rgba(255, 255, 255, 0.3) 0%,
    rgba(235, 235, 235, 0.17) 20.07%,
    rgba(224, 224, 224, 0.19) 28.14%,
    rgba(212, 212, 212, 0.11) 39.91%,
    rgba(207, 207, 207, 0.08) 48.1%,
    rgba(202, 202, 202, 0.04) 53.59%,
    rgba(200, 200, 200, 0.03) 58.73%,
    rgba(196, 196, 196, 0.1) 66.8%
  );
  box-shadow: 0 0.0625rem 1.5rem -0.0625rem rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(0.75rem);
}
.select_box {
  z-index: 999;
  width: 15.625rem;
  height: 2.5rem;
  border-radius: 1.25rem;
  background: linear-gradient(
    180deg,
    rgba(49, 58, 91, 0) 0%,
    #313a5b 45%,
    rgba(49, 58, 91, 0.22) 100%
  );
  backdrop-filter: blur(0.625rem);
  border-top: 0.0625rem solid #7abdff;
}
:deep(.el-input__wrapper),
:deep(.el-select),
:deep(.el-input),
:deep(.is-focus),
:deep(.el-input__inner) {
  background: rgba(21, 43, 94, 0);

  color: #b6b7bc99;

  border: none;
  box-shadow: none;

  border-radius: 0;

  text-align: center;
}
.i_box_active {
  background: rgb(115, 197, 254);
}
.c_box_active {
  background: #6f6f6f;
}
:deep(.el-select) :deep(.el-input__wrapper.is-focus) {
  box-shadow: 0 0 0 0 #ffffff00 !important;
}
:deep(.el-select) :deep(.el-input.is-focus) :deep(.el-input__wrapper) {
  box-shadow: 0 0 0 0 #ffffff00 !important;
}

:deep(.el-select__popper.el-popper) {
  background: linear-gradient(
    180deg,
    rgba(49, 58, 91, 0) 0%,
    #313a5b 35.64%,
    rgba(49, 58, 91, 0.22) 100%
  ) !important;
  box-shadow: 0 14px 20px 0 rgba(42, 51, 83, 0.8) !important;
  backdrop-filter: blur(10) !important;
}
.language {
  font-size: 12px;
  margin: 0 20px;
  display: flex;
  flex-flow: column;
  align-items: center;

  .lang {
    cursor: pointer;

    &.current {
      font-size: 16px;
    }
  }
}
.top-auto-complete{
  width:100%
}
.separator-autocomplete{
  border-radius: 20px !important;
  border: 1px solid #979797 !important;
  background: rgba(18, 24, 49, 0.90) !important;
  color:#FFFFFF !important;
}
.separator-autocomplete .el-autocomplete-suggestion li{
  color:#FFFFFF !important;
  border: none !important;
}
.separator-autocomplete .el-autocomplete-suggestion li:hover{
  background: #409eff !important;
}
.separator-autocomplete>.el-popper__arrow{
  display: none;
}
</style>
